import React from "react";
import { Route, Redirect } from "react-router-dom";
import Layout from "../hoc/Layout/Layout";

export const Router = ({ component: Component, ...rest }) => {

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          {rest.condition ? <Component {...props} /> : <Redirect to="/" />}
        </Layout>
      )}
    ></Route>
  );
};
